import { CalcRowFormulaController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Formula editor for a calculation row (UserDefinedRow).
 * @example
 * ```html
 * <salaxy-calc-row-formula row="$ctrl.current"></salaxy-calc-row-formula>
 * ```
 */
export class CalcRowFormula extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** The calculation row. */
      row: "<"
    };

    /** Uses the CalcRowFormulaController */
    public controller = CalcRowFormulaController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/rows/CalcRowFormula.html";
}

